import React from 'react';
import FocusTrap from 'focus-trap-react';
import _ from 'lodash';

/**
 * Globally shared focus trap stack. This allows proper coordination between all
 * focus trap instances, so that only the "top" focus trap is active at any given time.
 */
const GLOBAL_TRAP_STACK = [];

/**
 * Use this component if you want to trap focus within a certain area of the page. Trapping focus means that the user will
 * not be able to use the 'Tab' key on the keyboard to focus an element outside of this trap. This is useful for modals,
 * when you don't want anything behind the modal to get focus.
 * @param props Options passed along to the focus-trap-react library
 * @returns {Element}
 */
const TarasaFocusTrap = (props) => {
    // Build a new focus trap options object that ensures that we can have nested focus traps, and that portals still work
    const options = {
        // Copy the provided options
        ..._.defaultTo(props.focusTrapOptions, {}),

        // Use a global trap stack, so that only the "top" focus trap is active at any given time
        trapStack: GLOBAL_TRAP_STACK,

        // Allow clicks outside the focus trap, because e.g. react-select renders its options in a portal which is outside of the trap
        allowOutsideClick: true,
    };

    return <FocusTrap {...props} focusTrapOptions={options} />;
};

export default TarasaFocusTrap;
